import * as types from '@store/types'
import axios from 'axios'
import store from '@store'

const getSearchIndex = (options) => {
  const index = options.alphabetical ? 'campaigns_order_name'
    : options.alphainverse ? 'campaigns_order_name_desc'
      : options.nearby ? 'campaigns_order_nearby'
        : options.likes ? 'campaigns_order_likes'
          : options.discount ? 'campaigns_order_value'
            : 'campaigns'
  return index
}

const getSearchFilters = (options) => {
  const expressions = Object.entries({
    partner: `partner.slug: ${options.partner}`,
    highlight: 'is_highlighted: 1',
    exclusive: 'partner.is_exclusive: true',
    cashback: 'is_cashback: true'
  })

  const filters = expressions
    .filter(([filter]) => !!options[filter])
    .map(([_, expression]) => expression)
    .join(' AND ')

  return filters
}

const searchCampaigns = async (options) => {
  const filters = getSearchFilters(options)

  const params = {
    index: getSearchIndex(options),
    page: options.page || 0,
    query: options.query || undefined,
    hitsPerPage: options.quantity || 10,
    ...(filters ? { filters } : {})
  }

  const response = await axios.post('search', params, {
    cancelToken: options.cancel
  })
  const { hits: campaigns = [], nbHits: quantity = 0, page = 0 } = response.data || {}

  return {
    page,
    quantity,
    campaigns
  }
}

export const getCampaigns = async (options) => {
  try {
    const results = options.favorites
      ? await store.dispatch(types.FAVORITES_SEARCH, options)
      : await searchCampaigns(options)

    return results
  } catch (error) {
    return { campaigns: [], quantity: 0, page: 0 }
  }
}

export const getInformation = async (options) => {
  return {
    title: options.favorites ? 'Favoritos'
      : options.highlight ? 'Destaques'
        : options.query ? `Busca por: ${options.query}`
          : 'Todas as ofertas',

    icon: options.favorites ? 'bookmark'
      : options.highlight ? 'crown'
        : options.query ? 'search'
          : 'box2'
  }
}

export default getCampaigns



// WEBPACK FOOTER //
// ./src/store/modules/search-campaigns.js